import { useSearchParams } from 'react-router-dom'

import { TrackingQueueStatus } from './TrackingQueueStatus'
import { TrackingReporting } from './TrackingReporting'

type Tab = 'overview' | 'queue-status'

const tabs: { value: Tab; label: string }[] = [
  { value: 'overview', label: 'Overview' },
  { value: 'queue-status', label: 'Queue Status' },
]

const isValidTab = (value: string | null): value is Tab =>
  value === 'overview' || value === 'queue-status'

const TrackingReportsView = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeTab: Tab = isValidTab(tabParam) ? tabParam : 'overview'

  const setActiveTab = (tab: Tab) => {
    const params = new URLSearchParams(searchParams)
    params.set('tab', tab)
    setSearchParams(params, { replace: true })
  }

  return (
    <div className="space-y-6">
      <div role="tablist" className="tabs tabs-bordered">
        {tabs.map(tab => (
          <button
            key={tab.value}
            type="button"
            role="tab"
            className={`tab ${activeTab === tab.value ? 'tab-active' : ''}`}
            onClick={() => setActiveTab(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'overview' && <TrackingReporting />}
      {activeTab === 'queue-status' && <TrackingQueueStatus />}
    </div>
  )
}

export { TrackingReportsView }
